interface ResourceLink {
  text: string;
  href: string;
  hidden?: boolean;
}

export interface ResourcesMegaMenuLinkProps {
  title: string;
  links: ResourceLink[];
}

const ResourcesMegaMenuLinksData: ResourcesMegaMenuLinkProps[] = [
  {
    title: 'INSPIRATION & EDUCATION',
    links: [
      {
        text: 'People Magic Profit Masterclass',
        href: '/peoplemagic',
      },
      {
        text: 'People Magic Podcast',
        href: 'https://open.spotify.com/show/2TiP4Lihr9NMaZhGmviWY2?si=3810e7488d5f46aa',
      },
      {
        text: 'Case Studies',
        href: '/case-studies',
      },
      {
        text: 'Reviews',
        href: '/reviews',
      },
      {
        text: 'Blog',
        href: '/resources',
      },
    ],
  },
  {
    title: 'COMMUNITY & EVENTS',
    links: [
      {
        // Pending Link
        text: 'People Magic Summit',
        href: '/',
        hidden: true,
      },
      {
        text: 'Weekly Live Trainings',
        href: 'https://community.mightynetworks.com/events?utm_source=website&utm_medium=resources_menu&utm_campaign=weekly_trainings',
      },
      {
        text: 'Latest Feature Updates',
        href: 'https://community.mightynetworks.com/spaces/12890102/list?utm_source=website&utm_medium=resources_menu&utm_campaign=latest_updates',
      },
      {
        text: 'Build a Mighty Network Step by Step',
        href: 'https://community.mightynetworks.com/spaces/12898937/content?utm_source=website&utm_medium=resources_menu&utm_campaign=build_step_by_step',
      },
    ],
  },
  {
    title: 'SUPPORT',
    links: [
      {
        text: 'Help Center',
        href: 'https://faq.mightynetworks.com/en/',
      },
      {
        text: 'System Status',
        href: 'https://status.mightynetworks.com/',
      },
      {
        text: 'Trust Center',
        href: 'https://trust.mightynetworks.com/',
      },
    ],
  },
];

export default ResourcesMegaMenuLinksData;
